import type { IconSvgObject } from './types';

const EditOff03Icon: IconSvgObject = [
  ["path", { d: "M3.93838 15.6234L3.00008 21L8.37699 20.0615C8.78249 19.9908 9.15627 19.7966 9.44733 19.5055L20.5607 8.392C21.1465 7.80621 21.1465 6.85644 20.5606 6.27066L17.7292 3.43932C17.1434 2.85355 16.1937 2.85356 15.6079 3.43934L4.49439 14.5531C4.20332 14.8441 4.00915 15.2179 3.93838 15.6234Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 6L18 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default EditOff03Icon;
